import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';


const initialState: DashboardState = {
    files: [],
    transports: [],
};

const rootState: DashboardState = initialState;

const getters: GetterTree<DashboardState, RootState> = {
    toApprove(state: DashboardState): FvgDossier[] | undefined {
        return state.files.filter((file) => !file.AllowBooking);
    },
    urgent(state: DashboardState): FvgDossier[] | undefined {
        return state.files.filter((file) => file.IsUrgent);
    },
    transports(state: DashboardState): FvgTransport[] | undefined {
        return state.transports;
    },
};

const mutations: MutationTree<DashboardState> = {
    RESET(state: DashboardState) {
        Object.assign(state, initialState);
    },
    SET_ALL(state: DashboardState, results: FvgDashboard) {
        state.files = results.Files;
        state.transports = results.Transports;
    },
    SET_ALLOW_BOOKING(state: DashboardState, id: number) {
        const index = state.files.findIndex((dossier: FvgDossier) => dossier.Id === id);
        if (index !== -1) {
            // @ts-ignore
            this._vm.$set(state.files[index], 'AllowBooking', false);
        }
    },
};

const actions: ActionTree<DashboardState, RootState> = {
    read({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.get(`dashboard`)
            .then((data: ApiResponseDashboard) => {
                commit('SET_ALL', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
